module.exports = __webpack_public_path__ + "statics/img/SellAnywhere-1.f1be112b.png";